// 此文件由脚本自动生成，请勿直接修改。
// This file was generated automatically by a script. Please do not modify it directly.

import { ProgressTokens } from './type';

const progressTokens: ProgressTokens = {
  progressFontSize: 'Font-14',
  progressFontColor: 'Neutral-text-4',
  progressBackground: 'Neutral-fill-3',
  progressInfoFrontBackgroundColor: 'Brand-6',
  progressInfoInnerFontColor: 'Neutral-text-1',
  progressInfoBackgroundColor: 'Neutral-fill-3',
  progressWarningFrontBackgroundColor: 'Warning-6',
  progressWarningInnerFontColor: 'Neutral-text-1',
  progressWarningBackgroundColor: 'Neutral-fill-3',
  progressSuccessFrontBackgroundColor: 'Success-6',
  progressSuccessInnerFontColor: 'Neutral-text-1',
  progressSuccessBackgroundColor: 'Neutral-fill-3',
  progressDangerFrontBackgroundColor: 'Danger-6',
  progressDangerInnerFontColor: 'Neutral-text-1',
  progressDangerBackgroundColor: 'Neutral-fill-3',
  progressCircleInfoFontColor: 'Neutral-text-4',
  progressCircleWarningFontColor: 'Warning-6',
  progressCircleSuccessFontColor: 'success-6',
  progressCircleDangerFontColor: 'danger-6',
  progressCircleFontWeight: 'Weight-regular',
  progressLineHeight: 'Size-3',
  progressLineGap: 'Spacing-8',
  progressLineInnerHeight: 'Size-10',
  progressLineInnerGap: 'Spacing-8',
  progressLineInnerPaddingX: 'Spacing-8',
  progressLineInnerFontColor: 'Neutral-text-1',
  progressLineInnerFontSize: 'Font-12',
  progressLineInnerRightFontColor: 'Neutral-text-5',
  progressLineInnerInfoFrontBackgroundColor: 'Brand-6',
  progressLineInnerWarningFrontBackgroundColor: 'Warning-6',
  progressLineInnerSuccessFrontBackgroundColor: 'Success-6',
  progressLineInnerDangerFrontBackgroundColor: 'Danger-6',
  progressLinePopFontColor: 'Neutral-text-1',
  progressLineIconSize: 'Size-7',
  progressLineBackgroundColor: 'Neutral-fill-9',
  progressLineFontWeight: 'Weight-regular',
};

export default progressTokens;
